import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: { value: string; label: string }[];
  error?: string;
}

const Select: React.FC<SelectProps> = ({ label, options, error, ...rest }) => {
  return (
    <div className="w-full mb-4">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <select
        className={`mt-1 block w-full rounded-md border ${
          error ? 'border-red-500' : 'border-gray-300'
        } shadow-sm focus:border-primary focus:ring focus:ring-primary-light focus:ring-opacity-50 p-2`}
        {...rest}
      >
        <option value="">Select a country</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

export default Select;
